var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2668 18.214C15.1001 18.1973 14.9001 18.1973 14.7168 18.214C10.7501 18.0807 7.6001 14.8307 7.6001 10.8307C7.6001 6.74733 10.9001 3.43066 15.0001 3.43066C19.0834 3.43066 22.4001 6.74733 22.4001 10.8307C22.3834 14.8307 19.2334 18.0807 15.2668 18.214Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.35 6.76367C30.5833 6.76367 33.1833 9.38034 33.1833 12.597C33.1833 15.747 30.6833 18.3137 27.5666 18.4303C27.4333 18.4137 27.2833 18.4137 27.1333 18.4303",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93345 24.3637C2.90011 27.0637 2.90011 31.4637 6.93345 34.147C11.5168 37.2137 19.0334 37.2137 23.6168 34.147C27.6501 31.447 27.6501 27.047 23.6168 24.3637C19.0501 21.3137 11.5334 21.3137 6.93345 24.3637Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5667 33.4307C31.7667 33.1807 32.9 32.6973 33.8333 31.9807C36.4333 30.0307 36.4333 26.814 33.8333 24.864C32.9166 24.164 31.8 23.6973 30.6167 23.4307",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a77c11d233f26378a0f211fba9fa1ede.svg";
export { ForwardRef as ReactComponent };